import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { NAV_BAR_TYPES } from '@constants/actionTypes/navBarActionTypes';
import { LEFT_NAV_TYPES } from '@constants/actionTypes/leftNavTypes';
import { DELEGATION_HISTORY_TYPES, DELEGATION_FILTERS_TYPES, DELEGATION_PAGINATION_TYPES } from '@constants/actionTypes/delegationActionTypes';


export const setDelegationHistory = delegationHistory => ({
    type: DELEGATION_HISTORY_TYPES.SET_DELEGATION_HISTORY,
    delegationHistory
});

export const initDelegationFilters = filtersValues => ({
    type:  DELEGATION_FILTERS_TYPES.INIT_ALL_FILTERS,
    filtersValues
});

export const setFilterValue = newFilterValue => ({
    type: DELEGATION_FILTERS_TYPES.SET_FILTER_VALUE,
    newFilterValue
});

export const resetFilterValues = filtersInitialValues => ({
    type: DELEGATION_FILTERS_TYPES.RESET_FILTER_VALUES,
    filtersInitialValues
});

export const setPaginationCount = count => ({
    type: DELEGATION_PAGINATION_TYPES.SET_COUNT,
    count 
});

export const setNavBarData = navBarData => ({
    type: NAV_BAR_TYPES.SET_NAV_BAR_DATA,
    navBarData
});

export const setLeftNavParams = leftNavParams => ({
    type: LEFT_NAV_TYPES.SET_LEFT_NAV_PARAMS,
    leftNavParams
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const fetchDelegationData = url => async (dispatch, getState) => {
    const data = await API.getData(url, dispatch, actions, true, getState());
    if (data && data.responseCode === 200) {
        dispatch(setDelegationHistory(data.designationHistory));
        dispatch(setPaginationCount(data.count));
    } else {
        console.log('DelegationHistory Failure' );
    }
};

export const fetchNavBarData = url => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        dispatch(setNavBarData(data.menu));
    }
};

export const fetchLeftNavParams = url => async (dispatch, getState) => {
    const data = await API.getData(url, dispatch, actions, true, getState());
    if (data) {
        dispatch(setLeftNavParams(data));
    }
};

